import React, { createContext, useContext } from 'react';

const ThemeContext = createContext();

export const useTheme = () => {
  const context = useContext(ThemeContext);
  if (!context) {
    throw new Error('useTheme must be used within a ThemeProvider');
  }
  return context;
};

export const ThemeProvider = ({ theme = 'public', children }) => {
  const isPublic = theme === 'public';
  
  const themeStyles = {
    // Background colors
    bg: isPublic ? 'bg-gray-900' : 'bg-white',
    cardBg: isPublic ? 'bg-gray-900' : 'bg-white',
    cardBorder: isPublic ? 'border-gray-800' : 'border-gray-200',
    cardHover: isPublic ? 'hover:border-gray-700' : 'hover:border-gray-300 hover:shadow-md',
    
    // Text colors
    text: isPublic ? 'text-white' : 'text-gray-800',
    textSecondary: isPublic ? 'text-gray-300' : 'text-gray-600',
    textMuted: isPublic ? 'text-gray-400' : 'text-gray-600',
    
    // Input colors
    inputBg: isPublic ? 'bg-gray-900' : 'bg-white',
    inputBorder: isPublic ? 'border-gray-800' : 'border-gray-300',
    inputText: isPublic ? 'text-white' : 'text-gray-800',
    inputPlaceholder: isPublic ? 'placeholder-gray-500' : 'placeholder-gray-400',
    
    // Filter colors
    filterBg: isPublic ? 'bg-gray-900' : 'bg-white',
    filterBorder: isPublic ? 'border-gray-800' : 'border-gray-200',
    
    // Chip colors
    chipBg: isPublic ? 'bg-gray-800' : 'bg-gray-100',
    chipText: isPublic ? 'text-gray-300' : 'text-gray-800',
    chipSalary: isPublic ? 'text-[#06D6A0]' : 'text-green-600',
    
    // Button colors
    primaryGradient: 'bg-gradient-to-r from-[#0096C7] to-[#4361EE]',
    primaryHover: 'hover:from-[#00a8e0] hover:to-[#4a6bf5]',
    primaryText: 'text-white',
    
    // Border colors
    border: isPublic ? 'border-gray-800' : 'border-gray-200',
    borderLight: isPublic ? 'border-gray-700' : 'border-gray-300',
    
    // Icon colors
    iconPrimary: isPublic ? 'text-[#0096C7]' : 'text-primary-600',
    
    // Overlay colors
    overlayBg: isPublic ? 'bg-gray-900' : 'bg-white',
    overlayBorder: isPublic ? 'border-gray-800' : 'border-gray-200',
  };

  const value = {
    theme,
    isPublic,
    styles: themeStyles
  };

  return (
    <ThemeContext.Provider value={value}>
      {children}
    </ThemeContext.Provider>
  );
};